import { cn } from '@anytag/shared-utils';

export const stickyInfluencersSearchHeader = cn(
  'sticky top-0 z-4 h-(--sticky-influencers-search-height) bg-white',
  'before:h-50px before:absolute before:top-0 before:left-[-2px] before:block before:w-[2px] before:bg-black-10 before:content-[""]',
  'after:h-50px after:absolute after:top-0 after:right-[-2px] after:block after:w-[2px] after:bg-black-10 after:content-[""]'
);
